var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`button-tab ${_vm.isActive && '_active'}`,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{class:_vm.isActive && '_active'},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }